import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=2aa2212b&scoped=true&"
import script from "./SurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestion.vue?vue&type=style&index=0&id=2aa2212b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2212b",
  null
  
)

export default component.exports